module.exports = " <div>eet</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/eet/eet.component.html
// module id = 1204
// module chunks = 0